import {
  Button,
  Card,
  IconButton,
  LinearProgress,
  linearProgressClasses,
  Typography,
  Menu,
  MenuItem,
  ListSubheader,
  Box,
  CircularProgress,
  Tooltip,
  Divider,
  Grid,
  Link,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState, useRef } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import ReactGA from "react-ga4"
import RequestManualEvaluationDialog from "./RequestManualEvaluationDialog";
import { getTenantById, sendEvaluationEmail } from "./api/tenantApi";
// import { generateClient } from 'aws-amplify/api';
// import AWS from 'aws-sdk';
// import { Amplify } from "aws-amplify";
// import awsExports from "./aws-exports";
import { toast } from "react-toastify";
import SaveIcon from "./Assets/Images/saveIcon.svg";
import EditIcon from './Assets/Images/editIcon.svg'
// import { updateCompany, createRequestStatus } from "./graphql/mutations";
import { useSelector } from "react-redux";
import SendRequestModal from "./SendRequestModal";
import { formatScoreValue, formatCurrency, getScoreAttributes, MitigationOptions, isUnderwritingActive} from "./utils/Helper";
import { updateRequestedLimit, updateCompanySummary, getEligibleApprovers } from "./api/underwritingApi";
import requestStatusService from "./api/tenantApi";
import { startUnderwritingFlow, updateCompany } from "./api/companyApi";
import { getFreezeMessage } from "./utils/refreshFreeze";
import { useRolePermissions } from "./context/RolePermissionsContext";
import { MASKED_VALUE } from "./utils/rolePermissions";
import { RestrictedAction } from "./components/RestrictedAction";

// Amplify.configure(awsExports);
// const API = generateClient();

function ExecutiveSummary({
  company,
  summary,
  AgingDataForCompany,
  DnbData,
  tenantId,
  setShowExport,
  setCurrentCompany,
  executiveData,
  summaryScores,
  resolvedData = {},
  userInfo, // <-- add userInfo prop
  reFetchCompanyData,
  showInsured = false,
  insuredLimit = null,
}) {

  const recommended = Array.isArray(summary?.["Recommended Action"])
    ? MitigationOptions.filter(item =>
        summary["Recommended Action"].some(
          action => action.toLowerCase() === item.key?.toLowerCase()
        )
      )
    : [];
  const availableMitigations = recommended.length > 0 ? recommended : MitigationOptions;
  const hasRecommendations = recommended.length > 0;
  const [anchorEl, setAnchorEl] = useState(null);

  const [title, setTitle] = useState("");
  const [comment, setComment] = useState("");
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [specificCreditLimit, setSpecificCreditLimit] = useState("");
  const [loading, setLoading] = useState(true);
  const [requestLimitState, setRequestLimitState] = useState(false);
  const [loadingQuestion, setLoadingQuestion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileType, setFileType] = useState(null);
  const hasCompletedLoading = useRef(false);

  const {
    ARCScore,
    paymentIndex,
    legalScore,
    alternativeScore,
    countryScore,
    riskScore,
    recommendedLimit,
    recommendedLimitOriginalCurrency,
    recommendedLimitExchangeRateDate,
    originalCurrencyCode,
    requestedLimit,
    underwritingReason,
    currentArBalance,
    totalArBalance,
    termsRecommended,
    currentRecommended,
    paydex,
    tenure,
    avgCustomerPaymentDays,
    arrear,
    delinquencyScore,
    failureScore,
    sectorScore,
    altmanZScore,
    financialRiskScore,
    arBalance30,
    arBalance60,
    arBalance90,
    lastUpdatedDate,
  } = summaryScores;

  // Is there a real, finished ARC score to render? Prevents the broken smiley / NaN
  // progress bar / empty fields while a (newly added) company is still underwriting.
  const hasValidARCScore =
    ARCScore !== undefined &&
    ARCScore !== null &&
    ARCScore !== "" &&
    ARCScore !== "-" &&
    !isNaN(Number(ARCScore));
  const underwritingRunning = isUnderwritingActive(company);

  const isAdmin = useSelector((state) => state.userInfo.isAdmin);
  const { permissions } = useRolePermissions();

  const approvers = company?.approvers ? company.approvers : [];
  const approvalStatus = company?.approvalStatus ? company.approvalStatus : null;
  console.log("🚀 ~ approvers:", approvers)

  const initilRequestLimit = () => {
    if (summary) {
      const requestedLimit = isValid(company.requestedCreditLimit) ? parseFloat(company.requestedCreditLimit) : 0;
      return formatCurrency(requestedLimit);
    }
    return formatCurrency(0);
  };
  const [newRequestLimit, setNewRequestLimit] = useState(() =>
    initilRequestLimit()
  );

  const formatNumber = (number, currencySymbol = "US $") => {
    if (!isValid(number)) return null;
    if (
      typeof number === "string" &&
      (number.includes("US $") ||
        number.includes("$") ||
        number.includes("billion") ||
        number.includes("million") ||
        number.includes(","))
    ) {
      return number;
    }
    if (!number || isNaN(parseFloat(number))) return "";
    const num = parseFloat(number);
    
    // Determine if we need a space (for currency codes like USD, EUR) or not (for symbols like $, €)
    const needsSpace = currencySymbol && currencySymbol.length >= 3 && !currencySymbol.includes("$");
    const separator = needsSpace ? " " : "";
    
    if (num >= 1e9 || num <= -1e9) {
      return `${currencySymbol}${separator}${(num / 1e9).toFixed(2)} billion`;
    } else if (num >= 1e6 || num <= -1e6) {
      return `${currencySymbol}${separator}${(num / 1e6).toFixed(2)} million`;
    } else if (num >= 1e3 || num <= -1e3) {
      // Use Intl.NumberFormat for thousands
      return `${currencySymbol}${separator}${num.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
    } else {
      return `${currencySymbol}${separator}${num}`;
    }
  };

  const manualSource = company?.manualSource
    ? JSON.parse(company.manualSource)
    : {};

  useEffect(() => {
    if (company && summary && Object.keys(summary).length > 0 && tenantId && !hasCompletedLoading.current) {
      const timeoutId = setTimeout(() => {
        setLoading(false);
        setShowExport(true);
        hasCompletedLoading.current = true;
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [company, summary, tenantId, setShowExport]);

  // Reset loading state when company changes
  useEffect(() => {
    const companyId = company?.companyId || company?.id;
    if (companyId) {
      hasCompletedLoading.current = false;
      setLoading(true);
    }
  }, [company?.companyId, company?.id]);


  const handleCloseSR = () => {
    setIsModalOpen(false)
  };


  const handleMenuItemClick = (key) => {
    setFileType(key)
    setIsModalOpen(true);
    handleClose();
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleCommentsChange = (event) => {
    setComment(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleSpecificCreditLimitValue = (event) => {
    setSpecificCreditLimit(event.target.value);
  };

  const handleSubmit = async (row) => {
    const companyName = company?.companyName;
    try {
      let limit;
      if (selectedOption === "Specific Credit Limit") {
        limit = specificCreditLimit;
      } else {
        limit = "Max";
      }

      
      const compositeID = company?.id;
      const secondPart = compositeID ? compositeID.split('_')[1] : null;
      const companyId = secondPart ? secondPart : compositeID;
      let tenant = await getTenantById(tenantId);
      const tenantName = tenant?.data?.name;
      const now = new Date().toISOString();
      // The team-notification email (to michal + nimrod) is now sent SERVER-SIDE from this same
      // create-request-status call — the reliably-persisted path — so it can't be silently dropped
      // the way the old fire-and-forget client email was. We pass the email fields along for it.
      const dbResponse = await requestStatusService.createRequestStatus({
        tenantId: tenantId,
        companyName: companyName,
        tenantName: tenantName,
        companyId,
        requestType: "Manual Evaluation",
        requestStatus: "sent",
        requestDate: now,
        statusChangeDate: now,
        comments: comment,
        email: email,
        phoneNo: phoneNumber,
        requestedAmount: limit,
        fullName,
        title,
        recommendedLimit: company?.summaryData?.["Recommended Limit"],
      })

      console.log("Saved to DB", dbResponse);
      setComment("");
      setFullName("");
      setTitle("");
      setEmail("");
      setPhoneNumber("");
      setSelectedOption("");
      setSpecificCreditLimit("");
      handleCloseDialog();
      toast.success("Evaluation request sent successfully!")
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred while sending the evaluation request. Please try again later.");
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleManualEvaluationClick = (event) => {
    setIsDialogOpen(true);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  function extractNumber(value) {
    if (!value || value.trim() === "") {
      return 0;
    }
    const extractedNumber = value.replace(/[^0-9.]/g, "");
    return parseFloat(extractedNumber) || 0; // Return 0 if parsing fails
  }

  const updateRequestLimit = async () => {
    let newLimit = extractNumber(newRequestLimit) || 0;
    let oldLimit = extractNumber(requestedLimit) || 0;
    let UWRecommendation = extractNumber(recommendedLimit) || 0;

    if (oldLimit === newLimit) {
      setRequestLimitState(false);
      setNewRequestLimit(() => initilRequestLimit());
      return;
    }
    
    // Show confirmation dialog first
    setShowConfirmationDialog(true);
  };

  const confirmUpdateRequestLimit = async () => {
    setShowConfirmationDialog(false);
    setLoadingQuestion(true);
    
    try {
      let newLimit = extractNumber(newRequestLimit) || 0;
      let UWRecommendation = extractNumber(recommendedLimit) || 0;
      let oldLimit = extractNumber(requestedLimit) || 0;
      
      let requestedLimitTemp = formatCurrency(newLimit);
      setNewRequestLimit(requestedLimitTemp);
      await updateRequestedLimit(company?.tenantId, company?.companyId, oldLimit, newLimit, UWRecommendation);
      // Update Company using ./api/companyApi.js
      await updateCompany(company?.companyId, {
        tenantId: company?.tenantId,
        requestedCreditLimit: newLimit
      });
      // Update company summary to reset approval status and approved limit
      await updateCompanySummary(tenantId, company?.companyId, {
        approvalStatus: "PENDING",
        approvedLimit: 0
      });
      setApprovedLimit(0);
      toast.success("Requested Limit updated!");
      // Call getEligibleApprovers after both updates
      try {
        const approvers = await getEligibleApprovers({ companyId: company?.companyId, tenantId: company?.tenantId });
        console.log("Eligible Approvers (ExecutiveSummary):", approvers);
        // You can handle the approvers result as needed (e.g., show a dialog, update state, etc.)
      } catch (err) {
        console.error("Error fetching eligible approvers (ExecutiveSummary):", err);
      }
      try {
        if (newLimit > UWRecommendation) {
          // Guard: skip re-underwriting if this company's refresh is frozen
          const freezeBlock = getFreezeMessage(company);
          if (freezeBlock) {
            //toast.warning(freezeBlock);
          } else {
            await startUnderwritingFlow(tenantId, company?.companyId)
            toast.success('Underwriting flow started!', {
              bodyStyle: {
                fontWeight: "bold",
              },
            });
          }
        }
      } catch (err) {
        console.error("Error starting underwriting flow:", err);
        toast.error('Failed to start underwriting flow.');
      }
      setRequestLimitState(false);
      setLoadingQuestion(false)
    } catch (error) {
      console.error("Error updating request limit:", error);
      setRequestLimitState(false);
      setLoadingQuestion(false)
    }
  };

  const updateApprovedLimit = async () => {
    setLoadingApprovedLimit(true);
    try {
      const newLimit = extractNumber(newApprovedLimit) || 0;
      await updateCompanySummary(tenantId, company?.companyId, {
        approvedLimit: newLimit
      });
      setApprovedLimit(formatNumberSimple(newLimit));
      setNewApprovedLimit(formatNumberSimple(newLimit));
      setApprovedLimitEditState(false);
      setLoadingApprovedLimit(false);
      reFetchCompanyData();
      toast.success("Approved Limit updated!");
    } catch (error) {
      setLoadingApprovedLimit(false);
      toast.error("Failed to update Approved Limit.");
      console.error("Error updating approved limit:", error);
    }
  };

  // Add this new function for simple number formatting without keywords
  const formatNumberSimple = (number, currencySymbol = "US $") => {
    if (!isValid(number)) return null;
    if (
      typeof number === "string" &&
      (number.includes("US $") ||
        number.includes("$") ||
        number.includes(","))
    ) {
      return number;
    }
    if (!number || isNaN(parseFloat(number))) return "";
    const num = parseFloat(number);
    
    // Determine if we need a space (for currency codes like USD, EUR) or not (for symbols like $, €)
    const needsSpace = currencySymbol && currencySymbol.length >= 3 && !currencySymbol.includes("$");
    const separator = needsSpace ? " " : "";
    
    return `${currencySymbol}${separator}${num.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: "12.78px",
    borderRadius: 5,
    width: "199.68px",
    boxShadow: "inset 0px 3px 6px rgba(0, 0, 0, 0.16)",
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: getScoreAttributes(ARCScore).color,
    },
  }));

  function isValid(value) {
    return value !== null && value !== undefined && value !== "";
  }

  // Get all fields from resolvedData where source is "manualSource"
  const manualSourceFields = Object.entries(resolvedData || {})
    .filter(([key, data]) => data?.source === 'manualSource' && data?.value)
    .map(([key, data]) => ({
      label: key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1'), // Convert camelCase to Title Case
      key: key,
      value: data.value
    }));

  // The "Address" field shows the office address, falling back to the best available location
  // (HQ, then city, then country, and finally the location named in the Description) so it
  // reliably appears even when no structured location field resolved — the office/jurisdiction
  // is what matters in this box. Upgrades automatically to a full street address once one resolves.
  const extractLocationFromText = (text) => {
    if (!text || typeof text !== "string") return "";
    const patterns = [
      /headquarter(?:s|ed)?\s+(?:are\s+|is\s+)?(?:in|located in|based in|at)\s+(?:the\s+)?([A-Z][A-Za-z .'-]+(?:,\s*[A-Z][A-Za-z .'-]+)?)/,
      /(?:headquartered|based|located|registered|incorporated)\s+in\s+(?:the\s+)?([A-Z][A-Za-z .'-]+(?:,\s*[A-Z][A-Za-z .'-]+)?)/,
    ];
    for (const re of patterns) {
      const m = text.match(re);
      if (m && m[1]) return m[1].trim().replace(/[.,;]+$/, "");
    }
    return "";
  };
  const addressDisplayValue =
    resolvedData?.address?.value ||
    resolvedData?.headquarters?.value ||
    resolvedData?.city?.value ||
    resolvedData?.country?.value ||
    extractLocationFromText(resolvedData?.description?.value) ||
    "";
  // Effective value for a field key (applies the address fallback above).
  const fieldValue = (key) => (key === "address" ? addressDisplayValue : resolvedData?.[key]?.value);

  // Executive info fields mapping - include predefined fields and manual source fields
  const standardFields = [
    { label: "Description", key: "description" },
    { label: "Main sector", key: "industry" },
    { label: "Symbol", key: "ticker" },
    { label: "Founded", key: "founded" },
    { label: "Revenue", key: "revenue" },
    { label: "Net income", key: "netIncome" },
    { label: "Number of employees", key: "employees" }, 
    { label: "Main location office", key: "headquarters" },
    { label: "Address", key: "address" },
    { label: "Market cap", key: "marketCap" },
    { label: "Credit Rating", key: "creditRating" }, 
    { label: "Founders", key: "founders" }, 
    { label: "Key staff", key: "keyPeople" }, 
    { label: "Parent company", key: "parentCompany" }, 
    { label: "Website", key: "website" },
    { label: "Main competitors", key: "competitors" }, 
    { label: "Social media", key: "socialMedia" }, 
    { label: "Email address", key: "emailAddress" }, 
    { label: "Company phone", key: "phone" },
    { label: "Market", key: "market" } 
  ].filter(({ key }) => {
    const value = fieldValue(key);
    if (!value) return false;

    // Special handling for keyPeople - check if any roles have non-empty names
    if (key === "keyPeople" && typeof value === "object") {
      return Object.values(value).some(name => {
        if (!name) return false;
        if (typeof name !== 'string') return false;
        return name.trim() !== "";
      });
    }
    
    // Special handling for socialMedia - check if any platforms have non-empty URLs
    if (key === "socialMedia" && typeof value === "object") {
      return Object.values(value).some(url => {
        if (!url) return false;
        if (typeof url !== 'string') return false;
        return url.trim() !== "";
      });
    }
    
    return true;
  }); // Only include fields that have meaningful data

  // Combine standard fields with manual source fields, avoiding duplicates
  const execFields = [...standardFields];
  
  // Add manual source fields that are not already in standard fields
  manualSourceFields.forEach(manualField => {
    const exists = execFields.some(field => field.key === manualField.key);
    if (!exists) {
      execFields.push(manualField);
    }
  });

  const moneyFields = [
    "revenue",
    "marketCap",
    "totalAssets",
    "netIncome",
    "EBITDA",
    "equity",
    "totalLiabilities",
    "longTermDebt",
    "cashAndCashEquivalents",
    "operatingIncome"
  ];

  const renderValue = (key, value) => {
    if (!value) return null;

    // Special handling for socialMedia
    if (key === "socialMedia" && typeof value === "object" && value !== null) {
      return Object.entries(value)
        .filter(([platform, url]) => url && url.trim() !== "")
        .map(([platform, url], idx, arr) => (
          <span key={platform}>
            <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#1E90FF", textDecoration: "underline" }}>
              {platform.charAt(0).toUpperCase() + platform.slice(1)}
            </a>
            {idx < arr.length - 1 ? ", " : ""}
          </span>
        ));
    }

    // Special handling for keyPeople (object)
    if (key === "keyPeople" && typeof value === "object" && value !== null) {
      const roles = [];
      if (value.chairman) roles.push(`Chairman: ${value.chairman}`);
      if (value.ceo) roles.push(`CEO: ${value.ceo}`);
      Object.entries(value).forEach(([role, name]) => {
        if (name && !['chairman', 'ceo'].includes(role.toLowerCase())) {
          const formattedRole = role.charAt(0).toUpperCase() + role.slice(1);
          roles.push(`${formattedRole}: ${name}`);
        }
      });
      return roles.length > 0 ? roles.join(', ') : null;
    }

    // Special handling for money fields
    if (moneyFields.includes(key)) {
      // Check for resolvedData details
      const resolved = resolvedData?.[key];
      if (
        resolved &&
        resolved.value &&
        resolved.originalValue &&
        (resolved.currencyCode || resolved.currencySymbol) &&
        resolved.dateOfExchangeRateApplied &&
        resolved.currencyCode !== 'USD'
      ) {
        const formattedUSD = formatNumber(resolved.value, 'US $');
        const formattedOriginal = formatNumber(resolved.originalValue, resolved.currencyCode || resolved.currencySymbol);
        return `${formattedUSD} (${formattedOriginal}, ${resolved.dateOfExchangeRateApplied})`;
      }
      // fallback to previous formatting
      return formatNumber(value, 'US $');
    }

    // Special handling for website (make it a link)
    if (key === "website") {
      const url = value.startsWith("http://") || value.startsWith("https://")
        ? value
        : `https://${value}`;

      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      );
    }


    // Default: just return the value
    return value;
  };

  const ScoreCard = ({
    risk,
    alternative,
    delinquency,
    legal,
    paymentIndex,
    failure,
    sector,
    country,
    altmanZ,
    financialRisk,
  }) => {
    const scores = [
      { label: "Payment Index", value: paymentIndex, priority: 0 },
      { label: "Risk Segment", value: risk, priority: 1 },
      { label: "Pulse Index", value: alternative, priority: 2 },
      { label: "Delinquency Score", value: delinquency, priority: 3 },
      { label: "Legal Score", value: legal, priority: 4 },
      { label: "Failure Score", value: failure, priority: 5 },
      { label: "Sector Score", value: sector, priority: 6 },
      { label: "Country Score", value: country, priority: 7 },
      { label: "Altman Z Score", value: altmanZ, priority: 8 },
      { label: "Financial Risk Score", value: financialRisk, priority: 9 },
    ];

    const availableScores = scores.filter(
      (score) =>
        score.value !== undefined &&
        score.value !== null &&
        !isNaN(score.value)
    );

    let nonAltmanScores = availableScores.filter(
      (score) => score.label !== "Altman Z Score" && score.label !== "Payment Index"
    );
    const paymentIndexScore = availableScores.find(score => score.label === "Payment Index");
    
    // Check if this is a DLocal company (tenant IDs: 2ab5560a-591e-49c4-b21c-728422144237, 80ca91bd-bc50-40c0-90b7-f0e65294d10e)
    const isDLocal = userInfo?.tenantId === "2ab5560a-591e-49c4-b21c-728422144237" || userInfo?.tenantId === "80ca91bd-bc50-40c0-90b7-f0e65294d10e" || tenantId === "2ab5560a-591e-49c4-b21c-728422144237" || tenantId === "80ca91bd-bc50-40c0-90b7-f0e65294d10e";
    
    // Sort all scores by value (highest first), then by priority
    nonAltmanScores.sort((a, b) => {
      if (b.value === a.value) {
        return a.priority - b.priority;
      }
      return b.value - a.value;
    });
    if (summaryScores?.paymentIndex && summaryScores?.isAgingCompany) {
      nonAltmanScores.unshift(paymentIndexScore);
    }
    if (nonAltmanScores.length < 4 && isValid(summaryScores?.altmanZScore)) {
      nonAltmanScores.push({ label: "Altman Z Score", value: summaryScores?.altmanZScore, priority: 7 })
    }

    let displayScores;
    if (isDLocal) {
      // For DLocal: Ensure Financial Risk Score is always included in top 4
      const financialRiskScore = nonAltmanScores.find(score => score.label === "Financial Risk Score");
      const otherScores = nonAltmanScores.filter(score => score.label !== "Financial Risk Score");
      
      if (financialRiskScore) {
        // Take top 3 other scores + Financial Risk Score, then sort by value
        const topOtherScores = otherScores.slice(0, 3);
        displayScores = [...topOtherScores, financialRiskScore];
        displayScores.sort((a, b) => {
          if (b.value === a.value) {
            return a.priority - b.priority;
          }
          return b.value - a.value;
        });
      } else {
        // If no Financial Risk Score, use normal logic
        displayScores = nonAltmanScores.length > 4 ? nonAltmanScores.slice(0, 4) : nonAltmanScores;
      }
    } else {
      // For non-DLocal: Use normal logic
      displayScores = nonAltmanScores.length > 4 ? nonAltmanScores.slice(0, 4) : nonAltmanScores;
    }

    return (
      <div
        style={{
          width: "30%",
          gridTemplateColumns: "repeat(auto-fit, minmax(335px, 1fr))",
        }}
      >
        {displayScores.map((score, index) => (
          <React.Fragment key={index}>
            <Typography
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitBoxOrient: "horizontal",
                color: "#777A82",
                textAlign: "left",
                fontSize: "14px",
                paddingTop: "15px",
              }}
            >
              {score.label}:
            </Typography>
            <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title={score.value} arrow>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitBoxOrient: "horizontal",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "fit-content",
                  marginRight: "5px",
                  color: getScoreAttributes(score.value).color,
                }}
              >
                {permissions.canViewFinancialData ? formatScoreValue(score.value) : MASKED_VALUE}
                </Typography>
              </Tooltip>
              {permissions.canViewFinancialData && (
              <img
                src={getScoreAttributes(score.value).smiley}
                alt="smiley"
                height={"12.22px"}
                width={"10.9px"}
              />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  const truncateWithEllipsis = (text, maxLength = 120) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const [approvedLimitEditState, setApprovedLimitEditState] = useState(false);
  const [newApprovedLimit, setNewApprovedLimit] = useState(summaryScores.approvedLimit || "");
  const [loadingApprovedLimit, setLoadingApprovedLimit] = useState(false);
  const [approvedLimit, setApprovedLimit] = useState(summaryScores.approvedLimit || "");
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  // When entering edit mode, set newApprovedLimit to the raw number (unformatted)
  const handleApprovedLimitEdit = () => {
    let rawValue = approvedLimit;
    if (typeof rawValue === 'string') {
      rawValue = rawValue.replace(/[^\d.\-]/g, ''); // Remove all non-numeric except dot and minus
    }
    setNewApprovedLimit(rawValue);
    setApprovedLimitEditState(true);
  };

  // Get subId from localStorage
  const subId = typeof window !== 'undefined' ? localStorage.getItem('subId') : null;
  // Find if user is an approver
  const isUserApprover = Array.isArray(company?.approvers) && company.approvers.some(a => a.userId === subId);
  // Special role logic
  const specialRoles = ['YRNwGPczYAS9GMMa9ary', 'jHiUDvpJjSuv8cIdpOc6'];
  const isSpecialRole = specialRoles.includes(userInfo?.roleId);

  return (
    <Box padding={'25px'}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "stretch", gap: "20px" }}>
        {/* Left side: ARC Score, buttons, etc. */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {loading || underwritingRunning || !hasValidARCScore ? (
            <Card
              style={{
                flex: 1,
                minHeight: "335px",
                height: "100%",
                background: "rgba(250, 250, 252, 1) 0% 0% no-repeat padding-box",
                boxShadow:
                  "inset 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.16)",
                borderRadius: "8px",
                opacity: 1,
                padding: "25px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "14px",
                textAlign: "center",
              }}
            >
              {loading || underwritingRunning ? (
                <>
                  <CircularProgress size={36} thickness={4} sx={{ color: "#5186EC" }} />
                  <Typography style={{ fontSize: "15px", fontWeight: 600, color: "#2F3D63" }}>
                    {underwritingRunning ? "Underwriting in progress…" : "Loading…"}
                  </Typography>
                  {underwritingRunning && (
                    <Typography style={{ fontSize: "12.5px", color: "#777A82", maxWidth: "270px", lineHeight: 1.5 }}>
                      The ARC score, recommended limit and rationale will appear here automatically once the analysis completes.
                    </Typography>
                  )}
                </>
              ) : (
                <>
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      background: "#EEF3FF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#5186EC",
                      fontSize: 24,
                      fontWeight: 600,
                    }}
                  >
                    —
                  </div>
                  <Typography style={{ fontSize: "15px", fontWeight: 600, color: "#2F3D63" }}>
                    Not yet underwritten
                  </Typography>
                  <Typography style={{ fontSize: "12.5px", color: "#777A82", maxWidth: "270px", lineHeight: 1.5 }}>
                    Click <b>Refresh</b> to run the analysis and generate an ARC score and recommended limit.
                  </Typography>
                </>
              )}
            </Card>
          ) : (
            <Card
              style={{
                flex: 1,
                minHeight: "335px",
                height: "100%",
                background:
                  "rgba(250, 250, 252, 1) 0% 0% no-repeat padding-box",
                boxShadow:
                  "inset 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.16)",
                borderRadius: "8px",
                opacity: 1,
                padding: "25px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    width: "60%",
                    gridTemplateColumns: "repeat(auto-fit, minmax(335px, 1fr))",
                  }}
                >
                  <Typography
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "horizontal",
                      textAlign: "left",
                      fontSize: "16px",
                      color: "#2F3D63",
                      marginRight: "10px",
                      paddingRight: "10px",
                      fontWeight: "500",
                      paddingTop: 4,
                    }}
                  >
                    ARC Score
                  </Typography>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitBoxOrient: "horizontal",
                        textAlign: "left",
                        fontSize: "24px",
                        color: getScoreAttributes(ARCScore).color,
                        marginRight: "10px",
                        paddingRight: "10px",
                        fontWeight: "500",
                        paddingTop: 4,
                      }}
                    >
                      {permissions.canViewFinancialData ? ARCScore : MASKED_VALUE}
                    </Typography>
                    {permissions.canViewFinancialData && (
                    <img
                      src={getScoreAttributes(ARCScore).smiley}
                      alt="smiley"
                      height={"18px"}
                      width={"16px"}
                    />
                    )}
                  </div>
                  {permissions.canViewFinancialData && (
                  <BorderLinearProgress
                    variant="determinate"
                    value={ARCScore * 10}
                  />
                  )}
                  <Typography
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "horizontal",
                      width: "248px",
                      color: "#777A82",
                      textAlign: "left",
                      fontSize: "14px",
                      paddingTop: "15px",
                    }}
                  >
                    Recommended Limit:
                  </Typography>
                  <Typography
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "horizontal",
                      width: "153px",
                      textAlign: "left",
                      fontSize: "12px",
                      color: "#2F3D63",
                      marginRight: "10px",
                      paddingRight: "10px",
                      fontWeight: "500",
                      paddingTop: 4,
                    }}
                  >
                    {permissions.canViewFinancialData ? recommendedLimit : MASKED_VALUE}
                    {permissions.canViewFinancialData && (recommendedLimitOriginalCurrency && originalCurrencyCode !== "USD") && (
                      <> ({recommendedLimitOriginalCurrency}, {recommendedLimitExchangeRateDate})</>
                    )}
                  </Typography>
                  {requestLimitState && permissions.canRequestCreditLimit ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <input
                          type="text"
                          placeholder="in ($)"
                          onChange={(e) => setNewRequestLimit(e.target.value)}
                          value={newRequestLimit}
                          className="text-sm text-[#2F3D63] w-3/4 border-b-2 border-transparent bg-[#fafafc] focus:border-[#5186EC] focus:outline-none"
                        />
                        <div
                          onClick={loadingQuestion ? undefined : updateRequestLimit}
                          style={{
                            cursor: loadingQuestion ? "not-allowed" : "pointer",
                            opacity: loadingQuestion ? 0.5 : 1,
                          }}
                        >
                          <img src={SaveIcon} alt="save icon" style={{ width: "20px" }} />
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 8,
                          flex: "no",
                        }}
                      >
                        {newRequestLimit && (
                          <Typography
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitBoxOrient: "horizontal",
                              width: "153px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "#2F3D63",
                              marginRight: "10px",
                              paddingRight: "10px",
                              fontWeight: "500",
                              paddingTop: 4,
                            }}
                          >
                            [Requested : {permissions.canViewFinancialData ? newRequestLimit : MASKED_VALUE}]
                          </Typography>
                        )}
                        <RestrictedAction allowed={permissions.canRequestCreditLimit}>
                          <IconButton
                            onClick={() => setRequestLimitState(true)}
                            size="small"
                            sx={{ p: 0 }}
                          >
                            <img src={EditIcon} alt="edit icon" style={{ display: 'block', width: "20px" }} />
                          </IconButton>
                        </RestrictedAction>
                      </div>
                    )}
                  {termsRecommended && termsRecommended !== "-" && termsRecommended !== "N/A" && (
                    <>
                      <Typography
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "horizontal",
                          width: "248px",
                          color: "#777A82",
                          textAlign: "left",
                          fontSize: "14px",
                          paddingTop: "15px",
                        }}
                      >
                        Terms Recommended:
                      </Typography>

                      <Typography
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "horizontal",
                          width: "153px",
                          textAlign: "left",
                          fontSize: "12px",
                          color: "#2F3D63",
                          marginRight: "10px",
                          paddingRight: "10px",
                          fontWeight: "500",
                          paddingTop: 4,
                        }}
                      >
                        {termsRecommended}
                      </Typography>
                    </>
                  )}
                  {showInsured && (
                    <>
                      <Typography
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "horizontal",
                          width: "248px",
                          color: "#777A82",
                          textAlign: "left",
                          fontSize: "14px",
                          paddingTop: "15px",
                        }}
                      >
                        Insured Limit:
                      </Typography>

                      <Typography
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "horizontal",
                          width: "153px",
                          textAlign: "left",
                          fontSize: "12px",
                          color: "#2F3D63",
                          marginRight: "10px",
                          paddingRight: "10px",
                          fontWeight: "500",
                          paddingTop: 4,
                        }}
                      >
                        {/* Company's active cover limit; "-" when no carrier is connected. */}
                        {!permissions.canViewFinancialData
                          ? MASKED_VALUE
                          : insuredLimit != null
                            ? formatCurrency(insuredLimit)
                            : "-"}
                      </Typography>
                    </>
                  )}
                  {approvers.length > 0 && (
                    <>
                      <Typography
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "horizontal",
                          width: "248px",
                          color: "#777A82",
                          textAlign: "left",
                          fontSize: "14px",
                          paddingTop: "15px",
                        }}
                      >
                        Approved Limit:
                      </Typography>

                      {approvedLimitEditState ? (
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}>
                          <input
                            type="text"
                            placeholder="in ($)"
                            onChange={(e) => setNewApprovedLimit(e.target.value)}
                            value={newApprovedLimit}
                            className="text-sm text-[#2F3D63] w-3/4 border-b-2 border-transparent bg-[#fafafc] focus:border-[#5186EC] focus:outline-none"
                          />
                          <div
                            onClick={loadingApprovedLimit ? undefined : updateApprovedLimit}
                            style={{
                              cursor: loadingApprovedLimit ? "not-allowed" : "pointer",
                              opacity: loadingApprovedLimit ? 0.5 : 1,
                            }}
                          >
                            <img src={SaveIcon} alt="save icon" style={{ width: "20px" }} />
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}>
                          <Typography
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitBoxOrient: "horizontal",
                              width: "153px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "#2F3D63",
                              marginRight: "10px",
                              paddingRight: "10px",
                              fontWeight: "500",
                              paddingTop: 4,
                            }}
                          >
                            {approvedLimit}
                          </Typography>
                            {(isUserApprover || isSpecialRole) ? (
                              approvalStatus === "APPROVED" ? (
                                <Tooltip title="Approved limit cannot be modified when status is APPROVED" arrow>
                                  <div style={{ cursor: 'not-allowed', opacity: 0.5 }}>
                                    <img src={EditIcon} alt="edit icon" style={{ display: 'block', width: "20px" }} />
                                  </div>
                                </Tooltip>
                              ) : (
                                <RestrictedAction allowed={permissions.canApprove}>
                                  <IconButton onClick={handleApprovedLimitEdit} size="small" sx={{ p: 0 }}>
                                    <img src={EditIcon} alt="edit icon" style={{ display: 'block', width: "20px" }} />
                                  </IconButton>
                                </RestrictedAction>
                              )
                            ) : null}
                        </div>
                      )}
                      {(summaryScores?.previousApprovedLimit || summaryScores?.updatedApprovedLimit) && (
                        <div style={{ marginTop: 8, fontSize: "11px", color: "#6b7280" }}>
                          {summaryScores.previousApprovedLimit ? (
                            <div>Previous approved limit: {summaryScores.previousApprovedLimit}</div>
                          ) : null}
                          {summaryScores.updatedApprovedLimit ? (
                            <div>Updated recommended limit: {summaryScores.updatedApprovedLimit}</div>
                          ) : null}
                        </div>
                      )}
                    </>
                  )}
                  <Typography
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "horizontal",
                      color: "#777A82",
                      textAlign: "left",
                      fontSize: "14px",
                      paddingTop: "15px",
                    }}
                  >
                    Rationale:
                  </Typography>
                  <Typography
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "horizontal",
                      textAlign: "left",
                      fontSize: "12px",
                      color: "#2F3D63",
                      marginRight: "10px",
                      paddingRight: "10px",
                      fontWeight: "500",
                      paddingTop: 4,
                      paddingBottom: 20,
                    }}
                  >
                    {underwritingReason}
                  </Typography>
                </div>
                <ScoreCard
                  risk={riskScore}
                  alternative={alternativeScore}
                  delinquency={delinquencyScore}
                  legal={legalScore}
                  paymentIndex={paymentIndex}
                  failure={failureScore}
                  sector={sectorScore}
                  country={countryScore}
                  altmanZ={altmanZScore}
                  financialRisk={financialRiskScore}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "5px",
                }}
              >
                <Box>
                  {availableMitigations.length === 1 ? (
                    <RestrictedAction allowed={permissions.canSendMitigationRequest}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={false}
                      sx={{
                        background: "#5186EC 0% 0% no-repeat padding-box",
                        borderRadius: "6px",
                        backgroundColor: "#5186EC",
                        fontSize: "13px",
                        textTransform: "none",
                        fontWeight: "400",
                        lineHeight: "1",
                        margin: "0 auto",
                        padding: "8px",
                        textAlign: "center",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                      onClick={() => handleMenuItemClick(availableMitigations[0].key)}
                    >
                      {availableMitigations[0].value}
                    </Button>
                    </RestrictedAction>
                  ) : availableMitigations.length > 1 ? (
                    <RestrictedAction allowed={permissions.canSendMitigationRequest}>
                    <Button
                      id="action-button"
                      aria-controls={open ? "action-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      variant="contained"
                      color="primary"
                      disabled={false}
                      sx={{
                        background: "#5186EC",
                        borderRadius: "6px",
                        backgroundColor: "#5186EC",
                        width: "130px",
                        height: "30px",
                        fontSize: "13px",
                        textTransform: "none",
                        fontWeight: "400",
                        padding: "2px",
                      }}
                      endIcon={<KeyboardArrowDownIcon />}
                      onClick={handleClick}
                    >
                      Risk Mitigations
                    </Button>
                    </RestrictedAction>) : null}
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "action-button",
                    }}
                  >
                    {availableMitigations.length > 0 ? (
                      availableMitigations.map((item, index) => (
                        <div key={index}>
                          <MenuItem
                            onClick={() => handleMenuItemClick(item.key)}
                            sx={{ fontFamily: "Rubik, sans-serif" }}
                          >
                            {item.value}
                          </MenuItem>
                          {availableMitigations.length - 1 !== index && (
                            <Divider />
                          )}
                        </div>
                      ))
                    ) : null}
                  </Menu>
                      {isModalOpen && (
                    <SendRequestModal
                      open={isModalOpen}
                      onClose={handleCloseSR}
                      companyInfo={{
                        address: "",
                        domain: "",
                        name: company?.companyName,
                        companyId: company?.companyId,
                        requestedLimit: company?.requestedCreditLimit,
                      }}
                      fileType={fileType}
                      navigationFrom={"table"}
                    />
                      )}
                </Box>
                <Box>
                  <RestrictedAction allowed={permissions.canRequestManualEvaluation}>
                  <Button
                    id="action-button"
                    aria-controls={open ? "action-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    variant="contained"
                    color="primary"
                    disabled={false}
                    sx={{
                      background: "#5186EC",
                      borderRadius: "6px",
                      backgroundColor: "#5186EC",
                      height: "30px",
                      fontSize: "13px",
                      textTransform: "none",
                      fontWeight: "400",
                      padding: "5px",
                      lineHeight: "13px",
                    }}
                    onClick={handleManualEvaluationClick}
                  >
                    Request Manual Evaluation
                  </Button>
                  </RestrictedAction>
                </Box>
                <div style={{ display: isDialogOpen ? "block" : "none" }}>
                  <RequestManualEvaluationDialog
                    title={title}
                    comment={comment}
                    email={email}
                    fullName={fullName}
                    phoneNumber={phoneNumber}
                    isDialogOpen={isDialogOpen}
                    selectedOption={selectedOption}
                    specificCreditLimit={specificCreditLimit}
                    handleTitleChange={handleTitleChange}
                    handleCloseDialog={handleCloseDialog}
                    handleCommentsChange={handleCommentsChange}
                    handleEmailChange={handleEmailChange}
                    handleFullNameChange={handleFullNameChange}
                    handleOptionChange={handleOptionChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleSpecificCreditLimitValue={
                      handleSpecificCreditLimitValue
                    }
                    handleSubmit={handleSubmit}
                  />
                </div>
                
                {/* Confirmation Dialog for Request Limit Update */}
                {showConfirmationDialog && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 9999,
                    }}
                  >
                    <Card
                      style={{
                        padding: "24px",
                        maxWidth: "400px",
                        width: "90%",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          color: "#2F3D63",
                          marginBottom: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Warning
                      </Typography>
                      <Typography
                        style={{
                          color: "#777A82",
                          marginBottom: "24px",
                          lineHeight: "1.5",
                        }}
                      >
                        This change will restart the full approval process. The company's status will revert to "Pending" and the approval will follow the new requested limit.
                      </Typography>
                      <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                        <Button
                          variant="outlined"
                          onClick={() => setShowConfirmationDialog(false)}
                          style={{
                            borderColor: "#5186EC",
                            color: "#5186EC",
                            textTransform: "none",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={confirmUpdateRequestLimit}
                          style={{
                            backgroundColor: "#5186EC",
                            textTransform: "none",
                          }}
                        >
                          Confirm
                        </Button>
                      </div>
                    </Card>
                  </div>
                )}
              </div>
            </Card>
          )}
        </div>
        {/* Right side: Executive Info */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Card
            style={{
              minHeight: "335px",
              height: "100%",
              background: "rgba(250, 250, 252, 1) 0% 0% no-repeat padding-box",
              boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.16)",
              borderRadius: "8px",
              opacity: 1,
              padding: "25px",
              height: "100%"
            }}
          >
             <Grid container spacing={2} alignItems="flex-start">
               {(() => {
                 const columns = 3;
                 const fields = execFields.filter(({ key }) => {
                   const value = fieldValue(key);
                   if (!value) return false;

                   // Special handling for keyPeople - check if any roles have non-empty names
                   if (key === "keyPeople" && typeof value === "object") {
                     return Object.values(value).some(name => {
                       if (!name) return false;
                       if (typeof name !== 'string') return false;
                       return name.trim() !== "";
                     });
                   }
                   
                   // Special handling for socialMedia - check if any platforms have non-empty URLs
                   if (key === "socialMedia" && typeof value === "object") {
                     return Object.values(value).some(url => {
                       if (!url) return false;
                       if (typeof url !== 'string') return false;
                       return url.trim() !== "";
                     });
                   }
                   
                   return true;
                 });
                 const paddedFields = [...fields];
                 while (paddedFields.length % columns !== 0) {
                   paddedFields.push(null);
                 }
                 return paddedFields.map((field, idx) => {
                   if (!field) {
                     return (
                       <Grid item xs={12} sm={6} md={4} key={`empty-${idx}`} style={{ minHeight: 60 }} />
                     );
                   }
                   const { label, key } = field;
                   const value = fieldValue(key);
                   return (
                     <Grid item xs={12} sm={6} md={4} key={key} style={{ minHeight: 60 }}>
                       <Box display="flex" flexDirection="column" height="100%">
                         <Typography
                           style={{
                             color: "#777A82",
                             textAlign: "left",
                             fontSize: "14px",
                             paddingBottom: "5px",
                             minHeight: 20,
                           }}
                         >
                           {label}:
                         </Typography>
                         {label === "Description" ? (
                           <Tooltip title={value} arrow>
                             <Typography
                               style={{
                                 textAlign: "left",
                                 fontSize: "12px",
                                 color: "#2F3D63",
                                 fontWeight: "500",
                                 overflow: "hidden",
                                 cursor: "default",
                                 maxWidth: "100%",
                                 whiteSpace: "normal",
                                 wordBreak: "break-word",
                               }}
                             >
                               {truncateWithEllipsis(value, 120)}
                             </Typography>
                           </Tooltip>
                         ) : (
                           <Typography
                             style={{
                               textAlign: "left",
                               fontSize: "12px",
                               color: "#2F3D63",
                               fontWeight: "500",
                               overflow: "hidden",
                               maxWidth: "100%",
                               whiteSpace: "normal",
                               wordBreak: "break-word",
                             }}
                           >
                             {renderValue(key, value)}
                           </Typography>
                         )}
                       </Box>
                     </Grid>
                   );
                 });
               })()}
             </Grid>
           </Card>
        </div>
      </div>
    </Box>
  );
}

export default ExecutiveSummary;